// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ChartBarIcon } from '@moia-dev/pace-icons'
import { IncidentAnalysisAreaRoutes } from './IncidentAnalysisAreaRoutes'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const IncidentAnalysisAreaNavigationIcon = ChartBarIcon

export const IncidentAnalysisAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={IncidentAnalysisAreaRoutes.route}
      Icon={ChartBarIcon}
    />
  )
}
